/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElUpload as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/upload/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElIcon as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_0 from '~icons/ep/plus';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, isRef as _isRef, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-29a2cfa8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "el-upload__tip"
};
const _hoisted_2 = ["src"];
import ultraUploadFile from '../../utils/ultraUpload.js';
import { useModel } from '../../hooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: [Array, String],
      default: ''
    },
    text: {
      type: String,
      default: '点击上传'
    },
    // 允许上传文件最大数量
    limit: {
      type: Number,
      default: 20
    },
    // 是否禁用上传
    disabled: {
      type: Boolean,
      default: false
    },
    // 文件列表类型
    listType: {
      type: String,
      default: 'text'
    },
    // 是否支持多选文件
    multiple: {
      type: Boolean,
      default: false
    },
    // 展示上传列表
    showFileList: {
      type: Boolean,
      default: true
    },
    // 接受上传的文件类型
    accept: {
      type: String,
      default: ''
    },
    // 是否上传到私有桶
    isPrivate: {
      type: Boolean,
      default: false
    },
    // 上传文件之前
    beforeUpload: {
      type: Function,
      default: () => {
        return true;
      }
    },
    // 图片宽高
    imgWH: {
      type: Array,
      default: () => []
    },
    // 文件大小
    maxSize: {
      type: Number,
      default: 0,
      required: false
    },
    // 是否切片上传
    multiPart: {
      type: Boolean,
      default: false
    },
    timestamp: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'success', 'completeFile', 'remove'],
  setup(__props, {
    emit: __emit
  }) {
    let props = __props;
    // watch(() => props.modelValue, (val) => {
    // 	if (val) {
    // 		console.log('val===>', val);
    // 	}
    // }, { immediate: true });
    const emits = __emit;
    let fileList = useModel(() => {
      if (props.modelValue) {
        if (typeof props.modelValue === 'string') {
          return reactive([{
            name: '文件',
            url: props.modelValue
          }]);
        } else {
          return props.modelValue.map((item, index) => {
            // console.log('upload', item);
            if (typeof item === 'string') {
              return {
                url: item,
                name: `文件${index + 1}`
              };
            } else if (item.url) {
              return {
                ...item,
                name: item.name || item.url
              };
            } else {
              return {
                url: '',
                ...item
              };
            }
          });
        }
      } else {
        return [];
      }
    }, val => {
      return emits('update:modelValue', val);
    });
    const hiddenUpload = computed(() => {
      if (props.listType === 'picture-card') {
        if (fileList.value.length >= props.limit) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    });
    // 上传之前
    const handleBeforeUpload = async rawFile => {
      // 自定义beforeUpload
      let result = await props.beforeUpload(rawFile);
      if (!result) {
        return false;
      }
      // 判断文件大小
      if (props.maxSize > 0 && rawFile.size > props.maxSize) {
        ElMessage.warning('文件超出限制，请上传大小在' + parseInt(props.maxSize / 1024 + '') + 'Kb以内');
        return false;
      }
      // 判断图片尺寸
      if (props.imgWH.length > 0) {
        let width = props.imgWH[0] || 0;
        let height = props.imgWH[1] || 0;
        const {
          fw,
          fh
        } = await handleImgWH(rawFile);
        let res = await judgeFileWH(fw, fh, width, height);
        if (!res) {
          return false;
        }
      }
      return true;
    };
    // 获取上传图片的宽高
    const handleImgWH = file => {
      if (!file.type.includes('image')) {
        Promise.resolve({
          fw: 0,
          fh: 0
        });
      }
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('load', event => {
          const localUrl = event.target.result || '';
          const image = new Image();
          image.addEventListener('load', () => {
            const data = {
              fw: image.width,
              fh: image.height
            };
            resolve(data);
          });
          image.src = localUrl;
        });
        reader.readAsDataURL(file);
      });
    };
    // 判断图片宽高
    const judgeFileWH = (fw, fh, width, height) => {
      if (width && height) {
        if (fw === width && fh === height) {
          return true;
        } else {
          ElMessage.warning(`请上传尺寸宽高尺寸为${width}*${height}的图片`);
          return false;
        }
      } else if (width) {
        if (fw === width) {
          return true;
        } else {
          ElMessage.warning(`请上传尺寸宽为${width}的图片`);
          return false;
        }
      }
    };
    // interface CustomUploadRequestOptions extends UploadRequestOptions {
    // 	cancelUpload: boolean;
    // }
    // interface CustomUploadFile extends UploadFile{
    // 	cancelUpload: boolean;
    // }
    // 文件取消上传配置
    const fileCancel = {};
    // 上传
    const handleUpload = options => {
      console.log(options.file);
      const fileUid = options.file.uid;
      fileCancel[fileUid] = false;
      const params = {
        file: options.file,
        progressCb: percent => {
          options.onProgress({
            percent
          });
        },
        accept: props.accept,
        uploadingCb: cb => {
          return cb({
            cancelUpload: fileCancel[fileUid]
          });
        }
      };
      return new Promise((resolve, reject) => {
        ultraUploadFile({
          params,
          type: props.multiPart ? 2 : 1,
          isPrivate: props.isPrivate
        }).then(res => {
          console.log('res===>', res);
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      });
    };
    // 更新fileList
    const handleSetModelValue = files => {
      const _files = JSON.parse(JSON.stringify(files));
      _files.forEach(item => {
        item.url = item.response ? item.response.url : item.url;
        if (props.timestamp) {
          item.url = item.url + '?' + new Date().getTime();
        }
        delete item.response;
        delete item.raw;
      });
      fileList.value = _files;
    };
    // 上传成功
    const handleSuccess = (response, uploadFile, uploadFiles) => {
      emits('completeFile', uploadFile, response.url);
      emits('success', response, uploadFile, uploadFiles);
      handleSetModelValue(uploadFiles);
    };
    // 移除文件
    const handleRemove = (uploadFile, uploadFiles) => {
      console.log('移除文件======>');
      emits('remove', uploadFile);
      fileCancel[uploadFile.uid] = true;
      handleSetModelValue(uploadFiles);
    };
    // 超出限制
    const handleOnExceed = () => {
      ElMessage.warning(`已达到上传文件数限制${props.limit}`);
    };
    // 图片预览
    const dialogImageUrl = ref('');
    const dialogVisible = ref(false);
    const handlePictureCardPreview = file => {
      if (props.listType !== 'text') {
        dialogImageUrl.value = file.url;
        dialogVisible.value = true;
      }
    };
    return (_ctx, _cache) => {
      const _component_i_ep_plus = __unplugin_components_0;
      const _component_el_icon = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_upload = __unplugin_components_3;
      const _component_el_dialog = __unplugin_components_4;
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_upload, {
        class: _normalizeClass(_unref(hiddenUpload) ? 'hidden' : ''),
        ref: "upload",
        action: "",
        "list-type": __props.listType,
        "show-file-list": __props.showFileList,
        fileList: _unref(fileList),
        multiple: __props.multiple,
        disabled: __props.disabled,
        accept: __props.accept,
        "http-request": handleUpload,
        limit: __props.limit,
        "on-exceed": handleOnExceed,
        "on-success": handleSuccess,
        "on-remove": handleRemove,
        "before-upload": handleBeforeUpload,
        "on-preview": handlePictureCardPreview
      }, {
        tip: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "tip")])]),
        default: _withCtx(() => [__props.listType === 'picture-card' ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_plus)]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          disabled: __props.disabled,
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.text), 1)]),
          _: 1
        }, 8, ["disabled"]))]),
        _: 3
      }, 8, ["class", "list-type", "show-file-list", "fileList", "multiple", "disabled", "accept", "limit"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        "append-to-body": ""
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          "w-full": "",
          src: _unref(dialogImageUrl),
          alt: "Preview Image"
        }, null, 8, _hoisted_2)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});